import noUiSlider from 'nouislider';
import axios from 'axios';

export default {

  /**
   * possible child: s: season, g: gender, c: category, b: brand, r: range, o: special offer, q: search text
   */
  currentFilters: null,

  currentUpdateGetCancelToken: null,

  init() {
    // JavaScript to be fired on the products page

    /**************************************************/
    // init sort by dropdown
    /**************************************************/
    this.initSortBy();

    /**************************************************/
    // init filters
    /**************************************************/
    this.initFilters();

    /**************************************************/
    // init filters state
    /**************************************************/
    this.initFiltersState(true);
    this.updateFilterActiveState();
    this.fixMultipleSelectMobileStyle();

    /**************************************************/
    // init filters click
    /**************************************************/
    this.initFiltersActions();
    this.searchFormAction();

    /**************************************************/
    // init quick view click
    /**************************************************/
    this.initQuickViewActions();
  },

  finalize() {
    // JavaScript to be fired on the products page, after the init function
  },

  /**
   * On non touch devices filter menu select with multiple option selectable are rendered as list. Hide drop-down arrow.
   */
  fixMultipleSelectMobileStyle() {
    $('#catalogFiltersMobile').on('show.bs.collapse shown.bs.collapse', () => {
      setTimeout(() => {
        $('#catalogFiltersMobile [data-filter-select][multiple]').each( function() {
          const $this = $(this);
          if ($this.height() > 50) {
            $this.addClass('rendered-as-desktop-list');
          } else {
            $this.removeClass('rendered-as-desktop-list');
          }
        });
      }, 0);
    });
  },

  initQuickViewActions() {

    const $quickView = $('#quickView');
    const $quickViewIFrame = $quickView.find('iframe');

    $quickView.modal({
      show: false,
    });

    $quickView.on('hidden.bs.modal', () => {
      $quickView.find('iframe').attr('src', 'about:blank');
      $(window).off('iframeContentResize.productQuickViewModal');
      $quickViewIFrame.css('height', '');
    });

    $(document).on('click', '[data-quick-view]', (event) => {
      event.preventDefault();

      $quickViewIFrame.attr('src', $(event.currentTarget).data('quick-view-url'));
      $quickView.modal('show');

      $(window).on('iframeContentResize.productQuickViewModal', (event, iFrameHeight) => {
        $quickViewIFrame.css('height', iFrameHeight + 'px');
      });

    });
  },

  initFiltersState(onLoad) {

    const urlData = this.parseURL(window.location);

    this.currentFilters = {};

    // get query string filters
    for (const filter in urlData.searchObject) {

      switch (filter) {
        // array of int
        case 's':
        case 'b':
        case 'c':
        case "t":
          this.currentFilters[filter] = decodeURIComponent(urlData.searchObject[filter]).split(window.PRODUCTS_FILTERS.urlSeparator).map((id) => parseInt(id, 10)).filter((id) => !!id);
          break;

        // array of string
        case 'g':
          this.currentFilters[filter] = decodeURIComponent(urlData.searchObject[filter]).split(window.PRODUCTS_FILTERS.urlSeparator).map((id) => id.toLowerCase()).filter((id) => !!id);
          break;

        // boolean
        case 'o':
          this.currentFilters[filter] = 1;
          break;

        // boolean
        case 'e':
          this.currentFilters[filter] = 1;
          break;

        case 'r':
        case 'q':
          this.currentFilters[filter] = decodeURIComponent(urlData.searchObject[filter]);
          break;
      }
    }

    if(onLoad === true) {

      // get url filters
      let a, v;
      switch (true) {
        case window.PRODUCTS_FILTERS.currentRouteName.indexOf('.by_gender_man') !== -1:
          // console.log('by_gender_man filter');
          a = (this.currentFilters.g || []);
          if (a.indexOf('u') === -1)
            this.currentFilters.g = a.concat(['u']);
          break;

        case window.PRODUCTS_FILTERS.currentRouteName.indexOf('.by_gender_woman') !== -1:
          a = (this.currentFilters.g || []);
          if (a.indexOf('d') === -1)
            this.currentFilters.g = a.concat(['d']);
          break;

        case window.PRODUCTS_FILTERS.currentRouteName.indexOf('.by_gender_kid') !== -1:
          a = (this.currentFilters.g || []);
          if (a.indexOf('b') === -1)
            this.currentFilters.g = a.concat(['b']);
          break;

        case window.PRODUCTS_FILTERS.currentRouteName.indexOf('.by_brand') !== -1:
          a = (this.currentFilters.b || []);
          v = parseInt(urlData.pathname.split('.').pop(), 10);
          if (a.indexOf(v) === -1)
            this.currentFilters.b = a.concat([v]);
          break;

        case window.PRODUCTS_FILTERS.currentRouteName.indexOf('.by_category') !== -1:
          a = (this.currentFilters.c || []);
          v = parseInt(urlData.pathname.split('.').pop(), 10);
          if (a.indexOf(v) === -1)
            this.currentFilters.c = a.concat([v]);
          break;

        case window.PRODUCTS_FILTERS.currentRouteName.indexOf('.by_special_offers') !== -1:
          this.currentFilters.o = 1;
          break;

        case window.PRODUCTS_FILTERS.currentRouteName.indexOf('.by_extra_offers') !== -1:
          this.currentFilters.e = 1;
          break;
      }
    }

  },

  updateFilterActiveState() {
    const $selectedBrands = $('#selectedBrands');
    $('#catalogFiltersDesktop [data-filter-val]').removeClass('active');
    $('#catalogFiltersMobile [data-filter-select] option').removeAttr('selected');

    $selectedBrands.find('[data-filter-val]').remove();

    for (const filter in this.currentFilters) {
      if (!this.currentFilters.hasOwnProperty(filter))
        continue;

      // checkbox are special filter case
      if (filter === 'o') {
        $('#catalogFilters [data-filter-checkbox="'+filter+'"]').prop('checked', !!this.currentFilters[filter]);
        continue;
      }

      // checkbox are extra filter case
      if (filter === 'e') {
        $('#catalogFilters [data-filter-checkbox="'+filter+'"]').prop('checked', !!this.currentFilters[filter]);
        continue;
      }


      const $dg = $('#catalogFiltersDesktop [data-filter-group="'+filter+'"]');
      const $mg = $('#catalogFiltersMobile [data-filter-select="'+filter+'"]');

      if (Array.isArray(this.currentFilters[filter])) {
        if(this.currentFilters[filter].length) {
          for (const key in this.currentFilters[filter]) {
            if (!this.currentFilters[filter].hasOwnProperty(key))
              continue;
            const val = this.currentFilters[filter][key];
            $dg.find('[data-filter-val="'+val+'"]').addClass('active');
            $mg.find('option[value="'+val+'"]').attr('selected', true);

            let ele = $('[data-filter-group="b"] [data-filter-val="'+val+'"]').clone();
            ele.appendTo($selectedBrands);
          }
        }
      } else {
        if(this.currentFilters[filter]) {
          $dg.find('[data-filter-val="'+this.currentFilters[filter]+'"]').addClass('active');
          $mg.find('option[value="'+this.currentFilters[filter]+'"]').attr('selected', true);

          let ele = $('[data-filter-group="b"] [data-filter-val="'+this.currentFilters[filter]+'"]').clone();
          ele.appendTo($selectedBrands);
        }
      }
    }
  },

  toggleFilter(fo, replace) {
    const nf = jQuery.extend({}, this.currentFilters);

    for (const filter in fo) {
      if (!fo.hasOwnProperty(filter))
        continue;

      switch (filter) {
        case 's':
        case 'b':
        case 'c':
        case 'g':
        case "t":
          if(!replace) {
            for (const filterValue of fo[filter]) {
              if (!nf[filter] || nf[filter].indexOf(filterValue) === -1) {
                nf[filter] = (nf[filter] || []).concat([filterValue]);
              } else {
                nf[filter] = nf[filter].slice(0);
                nf[filter].splice(nf[filter].indexOf(filterValue), 1);
              }
            }
          } else {
            nf[filter] = fo[filter];
          }

          break;

        case 'o':
        case 'e':
        case 'r':
        case 'q':
            nf[filter] = fo[filter];
          break;
      }
    }

    let url = window.PRODUCTS_FILTERS.baseUrl + '?';

    for (const filter in nf) {
      if (!nf.hasOwnProperty(filter))
        continue;

      if (Array.isArray(nf[filter])) {
        if(nf[filter].length)
          url += filter + '=' + nf[filter].join(window.PRODUCTS_FILTERS.urlSeparator) + '&';
      } else {
        if(nf[filter])
          url += filter + '=' + nf[filter] + '&';
      }
    }

    // keep extra params between requests (like order)
    const urlData = this.parseURL(window.location);
    for (const searchObject in urlData.searchObject) {
      if (!searchObject || !urlData.searchObject.hasOwnProperty(searchObject))
        continue;

      // skip filter and page
      if (['s', 'b', 'c', 'g', 'o', 'e', 'r', 'page', 't', 'q'].indexOf(searchObject) !== -1)
        continue;

      url += searchObject + '=' + urlData.searchObject[searchObject] + '&';
    }

    if(url.endsWith('&') || url.endsWith('?')) {
      url = url.slice(0, -1);
    }

    this.updateProducts(url);
  },

  searchFormAction() {
    const $searchFormContainer = $('#searchForm');
    const $searchFormInput = $('#searchWords');
    const $form = $searchFormContainer.find('form');

    $form.on('submit', (event) => {
      event.preventDefault();

      const fo = {};

      if ($searchFormInput.val())
        fo['q'] = $searchFormInput.val();
      else
        fo['q'] = '';

      this.toggleFilter(fo, true);
    });

  },

  initFiltersActions() {

    $('#catalogFiltersDesktop').on('click', 'a[data-filter]', (event) => {
      event.preventDefault();
      const $target = $(event.currentTarget);
      const fo = $target.data('filter');
      this.toggleFilter(fo, false);

      if (!$target.closest('li').find('.lds-dual-ring').length)
        $target.closest('li').append('<div class="lds-dual-ring"></div>');

    });

    $('#catalogFiltersMobile').on('change', 'select[data-filter-select][multiple]', (event) => {
      const $target = $(event.currentTarget);
      const fo = {};
      fo[$(event.currentTarget).data('filter-select')] = $(event.currentTarget).val();
      this.toggleFilter(fo, true);

      if (!$target.siblings('label').find('.lds-dual-ring').length)
        $target.siblings('label').append('<div class="lds-dual-ring"></div>');
    });

    $('#catalogFilters').on('change', 'input[data-filter-checkbox]', (event) => {
      const $target = $(event.currentTarget);
      const fo = {};
      fo[$(event.currentTarget).data('filter-checkbox')] = $(event.currentTarget).is(':checked') ? 1 : 0;
      this.toggleFilter(fo, true);

      if (!$target.siblings('label').find('.lds-dual-ring').length)
        $target.siblings('label').append('<div class="lds-dual-ring"></div>');
    });

    /*
    $('#catalogFiltersMobile').on('change', '[data-filter-select]:not([multiple])', (event) => {
      const fo = {};
      fo[$(event.currentTarget).data('filter-select')] = $(event.currentTarget).val();
      toggleFilter(fo, true);
    });
    */

  },

  updateProducts(url) {
    //window.location = url;
    //return;

    if (this.currentUpdateGetCancelToken !== null)
      this.currentUpdateGetCancelToken.cancel('Operation canceled by multiple call');

    this.currentUpdateGetCancelToken = axios.CancelToken.source();

    history.pushState({}, '', url);
    this.initFiltersState(false);

    axios.get(url, {
      cancelToken: this.currentUpdateGetCancelToken.token
    }).then((response) => {

      const $result = $(response.data);
      let $filters;

      // update desktop filter quantity
      try {
        $filters = $result.find('#catalogFiltersDesktop a[data-filter]');

        $('#catalogFiltersDesktop a[data-filter]').each(function () {

          const $this = $(this);
          const $updatedThis = $filters.filter("[data-filter='" + $this.attr('data-filter') + "']");
          $this.children('span').replaceWith($updatedThis.children('span'));

          if ($updatedThis.closest('li').hasClass('empty'))
            $this.closest('li').addClass('empty');
          else
            $this.closest('li').removeClass('empty');
        });
      } catch (e) {}

      // update mobile filter quantity
      try {
        $filters = $result.find('#catalogFiltersMobile option[data-filter]');
        $('#catalogFiltersMobile option[data-filter]').each(function () {
          const $this = $(this);
          const $updatedThis = $filters.filter("[data-filter='" + $this.attr('data-filter') + "']");
          $this.text($updatedThis.text());
        });
      } catch (e) {}

      // update checkbox
      try {
        $filters = $result.find('#catalogFilters input[data-filter-checkbox]');
        $('#catalogFilters input[data-filter-checkbox]').each(function () {
          const $this = $(this);
          const $updatedThis = $filters.filter("[data-filter-checkbox='" + $this.attr('data-filter-checkbox') + "']").first();
          $this.siblings('label').children('span').text($updatedThis.siblings('label').children('span').text());
        });
      } catch (e) {}

      // update breadcrumb
      try {
        $('nav ul.breadcrumb').replaceWith($result.find('nav ul.breadcrumb'));
      } catch (e) {}

      // update products
      try {
        if(window.GOOGLE && window.GOOGLE.ga) {
          this.addImpressions($result.find('#productsList .products-grid li'));
        }

        $('#productsList').replaceWith($result.find('#productsList'));
      } catch (e) {}

      // update filter status
      try {
        this.updateFilterActiveState();
      } catch (e) {}

      // remove desktop loadings
      try {
        $('#catalogFiltersDesktop .lds-dual-ring').remove();
        $('#catalogFiltersMobile .lds-dual-ring').remove();
      } catch (e) {}

    }).catch((error) => {
      if (axios.isCancel(error)) {
        // console.log('Request canceled', error.message);
      } else {
        // TODO: handle error
      }
    });
  },

  initSortBy() {
    $('body').on('change', '#productsListSortByDropdown', (event) => {
      window.location = $(event.currentTarget).val();

      // TODO: user this.updateProducts(url) function to ajax loading

    });
  },

  initFilters() {
    // init brand filters
    this.initFilterByBrand();

    // init price range
    try {
      this.initPriceRange();
    } catch (e) {}
  },

  initFilterByBrand() {
    const notAllowedCodes = [9, 16, 17, 18, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 91, 93];
    const $searchInput = $('#catalogFiltersBrandsSearchTextInput');
    const $brandsListWrapper = $('#catalogFiltersBrandsList');
    const $brandsList = $brandsListWrapper.children('ul');
    const $noBrandsFound = $('<div class="no-brands">' + $brandsListWrapper.data('no-brands') + '</div>')

    $searchInput.keyup((e) => {
      // does not search if a special character was typed
      const charCode = (e.charCode) ? e.charCode : ((e.keyCode) ? e.keyCode : ((e.which) ? e.which : 0));
      if(notAllowedCodes.indexOf(charCode) !== -1) {
        return false;
      }

      const searchedWord = $(e.target).val();
      // hide brands which do not contain any typed words
      $brandsList.find('li a:not(:icontainsWords(' + searchedWord + '))').css('display', 'none');

      // show brands which contain at least one of the typed word
      const $brandsToShow = $brandsList.find('li a:icontainsWords(' + searchedWord + ')');

      // if there are no brands to show, show an alert message
      if($brandsToShow.length === 0) {
        if($noBrandsFound.parent().length === 0)
        {
          $brandsListWrapper.append($noBrandsFound);
        }
      }
      else {
        // if brands to show are found, remove the alert message
        if($noBrandsFound.parent().length > 0) {
          $noBrandsFound.remove();
        }
      }

      $brandsToShow.css('display', '');
    });
  },

  initPriceRange() {
    let setPriceRangeTimeout = null;
    const priceRange = document.getElementById('catalogFiltersPriceRange');

    if(priceRange)
    {
      const minPriceIndicator = $('#catalogFiltersPriceRangeIndicators .price-min-range > span');
      const maxPriceIndicator = $('#catalogFiltersPriceRangeIndicators .price-max-range > span');
      const minPriceValue = $('#catalogFiltersPriceRangeIndicators .price-min-range > input[type=hidden]');
      const maxPriceValue = $('#catalogFiltersPriceRangeIndicators .price-max-range > input[type=hidden]');

      noUiSlider.create(priceRange, {
        range: { 'min': $(priceRange).data('price-min'), 'max': $(priceRange).data('price-max') },
        start: [minPriceValue.val(), maxPriceValue.val()],
        step: $(priceRange).data('step'),
        margin: $(priceRange).data('min-range'),
        connect: [false, true, false]
      });

      // on range values change, update the indicator and the hidden values
      priceRange.noUiSlider.on('update', (values, handle) =>
      {
        const minPrice = Math.trunc(values[0]);
        minPriceIndicator.text(minPrice);

        const maxPrice = Math.trunc(values[1]);
        maxPriceIndicator.text(maxPrice);
      });

      // when the price range is updated, clear any interval started before to avoid refresh page while setting a new range
      priceRange.noUiSlider.on('update', (values, handle) => {
        clearTimeout(setPriceRangeTimeout);
      });

      // when an handle of price range is pressed down, clear any interval started before to avoid refresh page while setting a new range
      priceRange.noUiSlider.on('start', (values, handle) => {
        clearTimeout(setPriceRangeTimeout);
      });

      priceRange.noUiSlider.on('set', (values, handle) =>  {
        // on 'set' check if values have changed
        const minPrice = Math.trunc(values[0]);
        const maxPrice = Math.trunc(values[1]);

        if(minPrice !== minPriceValue.val() || maxPrice !== maxPriceValue.val()){
          // if changed starts a timeout, on its completion refresh the page with the new price range set
          setPriceRangeTimeout = setTimeout(() => {
            // refresh the page
            minPriceValue.val(minPrice);
            maxPriceValue.val(maxPrice);

            const fo = {};

            if ($(priceRange).data('price-min') === minPrice && $(priceRange).data('price-max') === maxPrice)
              fo['r'] = '';
            else
              fo['r'] = minPrice + ',' + maxPrice;

            this.toggleFilter(fo, true);

            if (!$(priceRange).closest('.price-range-group').children('h4').find('.lds-dual-ring').length)
              $(priceRange).closest('.price-range-group').children('h4').append('<div class="lds-dual-ring"></div>');

            // console.log('refresh');
          }, 500);
        }
      });
    }

  },

  parseURL(url) {
    const parser = document.createElement('a'),
      searchObject = {};
    let queries, split, i;
    // Let the browser do the work
    parser.href = url;
    // Convert query string to object
    queries = parser.search.replace(/^\?/, '').split('&');
    for( i = 0; i < queries.length; i++ ) {
        split = queries[i].split('=');
        searchObject[split[0]] = split[1];
    }
    return {
        protocol: parser.protocol,
        host: parser.host,
        hostname: parser.hostname,
        port: parser.port,
        pathname: (parser.pathname.indexOf('/') !== 0 ? '/' : '') + parser.pathname,
        search: parser.search,
        searchObject: searchObject,
        hash: parser.hash
    };
  },

  addImpressions(products) {

    ga('create', window.GOOGLE.ga);
    ga('require', 'ec');

    for (let i = 0; i < products.length; i++ ) {

      const product = $(products[i]);

      const productName = $(product).find('h2').html();
      const productId = $(product).data('product-id');
      const category = $(product).data('category-name');
      const brand = $(product).data('brand-name');
      const variant = $(product).data('variant-name');
      const list = $(product).data('list-name');
      const key = $(product).data('key');

      ga('ec:addImpression', {
        'id': productId,
        'name': productName,
        'category': category,
        'brand': brand,
        'variant': variant,
        'list': list,
        'position': key,
      });
    }

    ga('send', 'pageview');
  },
};
